var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.900000036
  }, /*#__PURE__*/React.createElement("g", {
    id: "People---Profile---Review-Action-points-inline-edit",
    transform: "translate(-1152.000000, -2542.000000)",
    fill: "#78909C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inline-Edit",
    transform: "translate(550.000000, 2530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(565.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(37.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43968,5.76 L11.37984,0.8208 C11.56704,0.6336 11.56704,0.33024 11.37984,0.14208 C11.19264,-0.04512 10.88832,-0.04512 10.70112,0.14208 L5.76,5.08176 L0.8208,0.14112 C0.6336,-0.04608 0.32928,-0.04608 0.14208,0.14112 C-0.04512,0.32928 -0.04512,0.63264 0.14208,0.81984 L5.08128,5.76 L0.14112,10.7016 C-0.04608,10.88976 -0.04608,11.19312 0.14112,11.38032 C0.23472,11.47392 0.35712,11.52096 0.48048,11.52096 C0.60384,11.52096 0.72672,11.4744 0.82032,11.3808 L5.76,6.4392 L10.70112,11.37984 C10.79472,11.47344 10.91712,11.52048 11.04048,11.52048 C11.16384,11.52048 11.28672,11.47392 11.38032,11.38032 C11.56752,11.19312 11.56752,10.88976 11.38032,10.7016 L6.43968,5.76 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGray);
export default __webpack_public_path__ + "static/media/close-gray.dd85b52793a56771f03ff2ec7bfbfb28.svg";
export { ForwardRef as ReactComponent };